export default "__VITE_ASSET__Bxxl10wc__"